import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiService } from '../../../common/api.service';

@Injectable({
  providedIn: "root",
})
export class FranchiseService {
  API_URL: string = environment.adminUrl + "/admin";
  API_URL2: string = environment.adminUrl;

  constructor(private http: HttpClient, private apiService: ApiService) { }

  getFranchiseRetailers(params): Observable<any> {
    const urlPath = this.API_URL + "/franchise/getUnderFranchiseRetailers";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getFranchiseRetailersReturns(params): Observable<any> {
    const urlPath = this.API_URL + "/franchise/getAllUnderFranchiseRetailersReturn";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getAllCNForFranchise(params): Observable<any> {
    const urlPath = environment.adminUrl + "/home/franchise/getAllCNForFranchise";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getChildInvoices(params): Observable<any> {
    const urlPath = environment.adminUrl + "/home/franchise/franchiseChildInvoices";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  paymentUpdate(body): Observable<any> {
    const urlPath = environment.adminUrl + "/home/franchise/updatePayment";
    return this.apiService.doPostObservableForQuery(urlPath, body, {});
  }

  getCommisionDetails(params): Observable<any> {
    const urlPath = environment.pharmaUrl + "/distribution/commission-details";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getCategoryWiseDetails(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/gmv-category";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getCategoryWiseCommissionDetails(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/commission";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getCategoryWiseCNCommissionDetails(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/creditnote-commission";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getGMVTotalValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/gmv";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getCreditNoteValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/credit-note-value";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getGMVTotalChartValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/daily-gmv";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getGMVTotalCNChartValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/credit-note-summary";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getTotalDueAmount(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/total-due";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getCreditCollectionValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/credit-collection";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getTotalChildRetailersCount(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/retailer-count";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getChildRetailerDetails(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/franchise-credit-summary";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getSanctionedLimitValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/sanctioned-limit";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }

  getAvailableLimitValue(params): Observable<any> {
    const urlPath = environment.adminUrl + "/reports/available-limit";
    return this.apiService.doGetObservableForQuery(urlPath, params);
  }


}